// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3733":"719191ab8a695139","7179":"327bcca24616ea54"}[chunkId] + ".css";
};